import { Stores } from "../modules/stores";

export const StoresPage = () => {
  return <Stores />;
};
